<template>
  <div class="flex">
    <div class="pr-3">
      <vs-avatar></vs-avatar>
    </div>
    <div class="flex-1 flex flex-col">
      <div class="w-full mb-3">
        <quill-editor v-model="comment" />
      </div>
      <!-- <vs-textarea placeholder="Tulis Komentar" v-model="comment"></vs-textarea> -->
      <div class="flex justify-end">
        <vs-button @click="submit" :disabled="loading">Kirim</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import { CREATE_KOMENTAR } from "@/query/komentar";
import { store as storeNotification } from "@/firebase/notification";
import QuillEditor from "@/components/global/text-editor/QuillEditor";

export default {
  components: {
    QuillEditor
  },
  props: {
    input: {
      type: Object
    },
    parentComment: {
      type: Object,
      required: false
    },
    commentableData: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      comment: "",
      loading: false
    };
  },
  methods: {
    async submit() {
      this.loading = true;
      await this.$apollo
        .mutate({
          mutation: CREATE_KOMENTAR,
          variables: {
            input: this.inputData,
            pengguna_id: this.$user.id
          }
        })
        .then(data => {
          this.comment = "";
          this.$emit("submitComment", data.data.komentarCreate);
          this.sendNotification(this.inputData);
        })
        .catch(error => {
          console.log(error);
          this.$vs.dialog({
            color: "danger",
            title: "Terjadi Kesalahan",
            text: "Silakan coba lagi atau hubungi tim IT"
          });
        });
      this.loading = false;
    },
    sendNotification(commentData) {
      var self = this;

      // Send a comment reply notification to single user
      if (
        commentData.komentar_id != null &&
        self.$sanctum.getUser().id != self.parentComment.pengguna_id
      ) {
        let data = {
          except_login_id: self.$sanctum.getUser().login_id,
          pengguna_id: self.parentComment.pengguna_id,
          pengguna_list: null,
          judul: "Notifikasi Komentar",
          konten: `Anda mendapatkan balasan komentar dari ${
            self.$sanctum.getUser().nama
          }`,
          halaman: "agenda-detail",
          notifikasiable_id: self.commentableData.id,
          notifikasiable_uuid: self.commentableData.uuid,
          ikon: "MessageSquareIcon"
        };
        storeNotification(data);
      }
      // Send comment notification to multiple user
      else if (
        commentData.komentar_id == null &&
        this.commentableData.additionalData.penggunaList.length != 0
      ) {
        let data = {
          except_login_id: self.$sanctum.getUser().login_id,
          pengguna_id: null,
          pengguna_list: self.commentableData.additionalData.penggunaList,
          judul: "Notifikasi Komentar",
          konten: `${
            self.$sanctum.getUser().nama
          } memberikan komentar pada agenda.`,
          halaman: "agenda-detail",
          notifikasiable_id: self.commentableData.id,
          notifikasiable_uuid: self.commentableData.uuid,
          ikon: "MessageSquareIcon"
        };
        storeNotification(data);
      }
    }
  },
  computed: {
    inputData() {
      const data = { ...this.input, komentar: this.comment };
      return data;
    }
  }
};
</script>
